import { Component, computed, inject, input, output } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { I18nService } from '../../services/i18n.service';
import { UiService } from '../../services/ui.service';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';
import { I18N_KEYS } from '../../enums/i18.enum';
import { NavButtonComponent } from '../nav-button/nav-button';
import { Plant_Structure_Enums } from '../../enums/global.enum';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.html',
  styleUrls: ['./delete-popup.scss'],
  imports: [NzModalModule, NavButtonComponent, NzIconModule],
})
export class DeletePopupComponent {
  objName = input<string>(GLOBAL_CONSTANT.EMPTY_STRING);
  objType = input<string>(GLOBAL_CONSTANT.EMPTY_STRING); // '', 'sensor', 'plant', 'area', 'building', 'floor', 'section', 'zone', 'scrossing', 'associatedeq'
  equipmentDeletePopup = input<boolean>(false);
  sensorDeletePopup = input<boolean>(false);

  closeEvent = output<boolean>();
  confirmDelete = output<any>();

  readonly i18n = inject(I18nService);
  private readonly ui = inject(UiService);

  isMobile = computed<boolean>(() => this.ui.IsMobile());

  isEquipmentOrSensor = computed<boolean>(() => {
    const type = this.objType();
    return type === Plant_Structure_Enums.SENSOR || type === GLOBAL_CONSTANT.EMPTY_STRING;
  });

  isEquipmentSensorDeleted = computed<boolean>(() => {
    return !!this.equipmentDeletePopup() || !!this.sensorDeletePopup();
  });

  deleteButtonTitle = computed<string>(() => {
    const type = this.objType();
    if (type === Plant_Structure_Enums.SENSOR) {
      return this.i18n.langString(I18N_KEYS.YES_DELETE_SENSOR);
    } else if (type === GLOBAL_CONSTANT.EMPTY_STRING) {
      return this.i18n.langString(I18N_KEYS.YES_DELETE_EQUIPMENT);
    }
    return GLOBAL_CONSTANT.EMPTY_STRING;
  });

  deleteTitle = computed<string>(() => {
    switch (this.objType()) {
      case Plant_Structure_Enums.PLANT:
        return this.i18n.langString(I18N_KEYS.DELETE_PLANT);
      case Plant_Structure_Enums.AREA:
        return this.i18n.langString(I18N_KEYS.DELETE_AREA);
      case Plant_Structure_Enums.BUILDING:
        return this.i18n.langString(I18N_KEYS.DELETE_BUILDING);
      case Plant_Structure_Enums.SENSOR:
        return this.i18n.langString(I18N_KEYS.DELETE_SENSOR);
      case Plant_Structure_Enums.FLOOR:
        return this.i18n.langString(I18N_KEYS.DELETE_FLOOR);
      case Plant_Structure_Enums.SECTION:
        return this.i18n.langString(I18N_KEYS.DELETE_SECTION);
      case Plant_Structure_Enums.ZONE:
        return this.i18n.langString(I18N_KEYS.DELETE_ZONE);
      case Plant_Structure_Enums.SCROSSING:
        return this.i18n.langString(I18N_KEYS.DELETE_SCROSSING);
      case Plant_Structure_Enums.ASSOCIATE_EQ:
        return this.i18n.langString(I18N_KEYS.DELETE_ASSOCIATEDEQ);
      default:
        return this.i18n.langString(I18N_KEYS.DELETE_EQUIPMENT);
    }
  });

  onClose(confirm: boolean) {
    this.closeEvent.emit(confirm);
  }
}
